import { render, staticRenderFns } from "./PlpTaskLog.vue?vue&type=template&id=c4622106"
import script from "./PlpTaskLog.vue?vue&type=script&lang=js"
export * from "./PlpTaskLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports